import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const deleteSavedEmailTemplate = {
  name: "deleteSavedEmailTemplate" as const,
  input: z.object({ savedTemplateId: zExt.objectId() }),
  output: z.object({ success: z.boolean(), message: z.string().optional() }),
};
